var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgReactionChatLite = function SvgReactionChatLite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E7E7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.066 28.763c-1.144-.376-3.738-2.34-5.98-4.387a15.058 15.058 0 01-3.707-5.67 6.08 6.08 0 01.798-5.71 5.29 5.29 0 014.167-1.988 6.8 6.8 0 014.762 2A5.916 5.916 0 0124.483 11a5.271 5.271 0 014.152 1.978 6.179 6.179 0 011.08 5.728 13.84 13.84 0 01-3.639 5.67c-2.134 1.949-4.85 4.142-6.01 4.387z",
    stroke: "#000",
    strokeWidth: 1.255
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    d: "M16.6 16.461v2.903M24.246 16.461v2.903M19.012 20.829a1.584 1.584 0 001.447 1.059 1.532 1.532 0 001.456-1.06",
    stroke: "#000",
    strokeWidth: 1.255,
    strokeLinecap: "round"
  })));
};
export default SvgReactionChatLite;